
import React from "react";
import { Link } from "react-router-dom";
import {
  BookOpen, Brain, ClipboardCheck, Target,
  BarChart3, FileText, ArrowRight, CheckCircle2
} from "lucide-react";

const recursos = [
  {
    icon: BookOpen,
    titulo: "Questões comentadas",
    descricao: "Pratique com questões organizadas por banca, concurso e disciplina."
  },
  {
    icon: ClipboardCheck,
    titulo: "Simulados",
    descricao: "Teste seus conhecimentos e acompanhe sua preparação."
  },
  {
    icon: Brain,
    titulo: "Professor IA",
    descricao: "Conte com inteligência artificial para apoiar seus estudos."
  },
  {
    icon: Target,
    titulo: "Plano de estudos",
    descricao: "Organize sua preparação com um plano de estudos adaptativo."
  },
  {
    icon: BarChart3,
    titulo: "Análise de desempenho",
    descricao: "Identifique seus pontos fortes e os assuntos que precisam de revisão."
  },
  {
    icon: FileText,
    titulo: "Materiais e mapas mentais",
    descricao: "Reforce o aprendizado com materiais em PDF e mapas mentais."
  }
];

export default function LandingPage() {
  return (
    <main className="min-h-screen bg-slate-950 text-white">
      <header className="border-b border-slate-800">
        <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-5 py-4">
          <Link to="/" aria-label="Página inicial ApoiaConcursos">
            <img
              src="/images/logo-apoiaconcursos.jpeg"
              alt="ApoiaConcursos"
              className="h-14 w-auto object-contain"
            />
          </Link>

          <Link
            to="/login"
            className="rounded-lg border border-emerald-500 px-5 py-2 font-semibold text-emerald-400 hover:bg-emerald-500/10"
          >
            Entrar
          </Link>
        </div>
      </header>

      <section className="mx-auto max-w-5xl px-5 py-20 text-center">
        <p className="mb-5 font-bold tracking-widest text-emerald-400">
          SEU APOIO PARA APROVAÇÃO
        </p>

        <h1 className="mb-7 text-4xl font-extrabold leading-tight md:text-6xl">
          Sua aprovação começa com
          <span className="text-emerald-400"> uma preparação inteligente.</span>
        </h1>

        <p className="mx-auto mb-9 max-w-3xl text-lg leading-relaxed text-slate-300">
          Prepare-se para concursos públicos com questões comentadas,
          simulados, inteligência artificial, mapas mentais e planos
          de estudo personalizados. Tudo em uma única plataforma.
        </p>

        <div className="flex flex-wrap justify-center gap-4">
          <Link
            to="/login"
            className="inline-flex items-center gap-2 rounded-xl bg-emerald-500 px-7 py-4 font-bold text-white hover:bg-emerald-600"
          >
            Começar gratuitamente <ArrowRight size={19} />
          </Link>

          <a
            href="#recursos"
            className="rounded-xl border border-slate-600 px-7 py-4 font-semibold hover:bg-slate-800"
          >
            Conhecer recursos
          </a>
        </div>

        <p className="mt-6 text-sm text-slate-400">
          Cadastro gratuito disponível. Recursos adicionais nos planos Premium.
        </p>
      </section>

      <section id="recursos" className="bg-slate-900/60 px-5 py-20">
        <div className="mx-auto max-w-6xl">
          <h2 className="mb-4 text-center text-3xl font-bold">
            Por que escolher o ApoiaConcursos?
          </h2>

          <p className="mx-auto mb-12 max-w-2xl text-center text-slate-400">
            Ferramentas para estudar com organização, praticar questões
            e acompanhar sua evolução.
          </p>

          <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {recursos.map((recurso) => {
              const Icone = recurso.icon;

              return (
                <article
                  key={recurso.titulo}
                  className="rounded-2xl border border-slate-800 bg-slate-950 p-7"
                >
                  <Icone className="mb-5 text-emerald-400" size={32} />
                  <h3 className="mb-3 text-xl font-bold">
                    {recurso.titulo}
                  </h3>
                  <p className="leading-relaxed text-slate-400">
                    {recurso.descricao}
                  </p>
                </article>
              );
            })}
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-5xl px-5 py-20 text-center">
        <h2 className="mb-6 text-3xl font-bold">
          Estude para concursos com mais foco
        </h2>

        <p className="mx-auto mb-8 max-w-3xl text-slate-300">
          Prepare-se para provas de bancas como Cebraspe e Cesgranrio.
          Organize sua rotina, pratique questões e acompanhe
          seu desenvolvimento durante os estudos.
        </p>

        <div className="mb-10 flex flex-wrap justify-center gap-5 text-sm text-slate-300">
          {["Questões", "Simulados", "Revisões", "Mapas mentais"].map((item) => (
            <span key={item} className="flex items-center gap-2">
              <CheckCircle2 className="text-emerald-400" size={18} />
              {item}
            </span>
          ))}
        </div>

        <Link
          to="/login"
          className="inline-flex items-center gap-2 rounded-xl bg-emerald-500 px-8 py-4 font-bold hover:bg-emerald-600"
        >
          Criar minha conta grátis <ArrowRight size={19} />
        </Link>
      </section>

      <footer className="border-t border-slate-800 px-5 py-8 text-center text-sm text-slate-400">
        <p className="font-semibold text-white">ApoiaConcursos</p>
        <p className="mt-2">SEU APOIO PARA APROVAÇÃO</p>
        <p className="mt-3">
          Plataforma independente de preparação para concursos públicos.
        </p>
      </footer>
    </main>
  );
}
